import { Card, CardContent, Container, Grid } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import NavigationPrompt from 'react-router-navigation-prompt';
import ConfirmationDialog from 'src/components/ConfirmationDialog/ConfirmationDialog';
import { APP_CONSTANT } from 'src/constants';
import { AppContext } from 'src/context/AppContextProvider';
import { t } from 'src/i18n';
import FormRenderer from '../../components/FormBuilder/forms/form-renderer';
import Routes from '../../modules/Navigator/Navigator.route';
import { useStyles } from '../Dashboard/Dashboard.style';
import { BackButton } from './FormSubmission.style';

interface IFormSubmissionProps {
  cookies: Record<string, any>;
}

const FormSubmission: React.FC<IFormSubmissionProps> = (props) => {
  const history = useHistory();
  const ownerId = new URLSearchParams(history.location.search).get('ownerId');

  // @ts-ignore
  const { formId, checksum, submissionId, secureSubmissionId } = useParams();
  const classes = useStyles();
  const context = useContext(AppContext);
  const token = props.cookies.token;

  const handleWhenToPrompt = (location, dest) => {
    if (token) {
      if (dest?.pathname === Routes.SignIn) {
        return false;
      }

      return (
        context.formState[`${ownerId}-${formId}`] !== APP_CONSTANT.PRISTINE
      );
    }

    return context.formState[formId] !== APP_CONSTANT.PRISTINE;
  };

  const handleAfterCancel = () => {
    context.setForceRender(!context.forceRender);
  };

  const onClickBack = () => {
    history.push(Routes.PatientDocument);
  };

  useEffect(() => {
    return () => {
      if (token) {
        context.setFormState({
          [`${ownerId}-${formId}`]: APP_CONSTANT.PRISTINE
        });
      } else {
        context.setFormState({
          [formId]: APP_CONSTANT.PRISTINE
        });
      }
    };
  }, []);

  return (
    <>
      <Container className="dashboard">
        <BackButton onClick={onClickBack}>
          ← {t('formSubmission.buttonBack')}
        </BackButton>
        <Grid item={true} xs={12} sm={12}>
          <Card className={`${classes.mb30} ${classes.borderRadius15}`}>
            <CardContent>
              <div className="class-name-form-unique">
                <FormRenderer
                  id={formId}
                  checksum={checksum}
                  submissionId={submissionId}
                  submissionChecksum={secureSubmissionId}
                  allowSubmit={true}
                  saveAsGuest={true}
                  ownerId={ownerId}
                />
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Container>
      <NavigationPrompt
        when={handleWhenToPrompt}
        afterCancel={handleAfterCancel}
      >
        {({ onConfirm, onCancel }) => (
          <ConfirmationDialog
            open={true}
            confirmHandler={onConfirm}
            cancelHandler={onCancel}
            textTitle={t('patientDocument.sendMessages.cancelPopup.title')}
            textDescription={t(
              'patientDocument.sendMessages.cancelPopup.description'
            )}
          />
        )}
      </NavigationPrompt>
    </>
  );
};

export default FormSubmission;
